/**
 * @fileoverview A hook that provides Redux dispatch and selector functions.
 *
 * @example
 * const { result } = renderHook(() => useAppDispatch())
 * expect(result.current).toBeDefined() // When dispatch is available
 */

import type { TypedUseSelectorHook } from 'react-redux'
import { useDispatch, useSelector } from 'react-redux'
import type { AppDispatch, RootState } from '../store'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
